.typeListWrapper {
  display: flex;
  max-width: 1150px;
  margin: auto;

  .typeListContainer {
    flex: 4;
  }
}
